const gmail = {
  inbox: "Inbox",
  unread: "Unread",
  from: "From",
  noMessages: "No new messages",
  noAccount: "No Gmail account connected",
  connectAccount: "Connect account in Settings",
  openInGmail: "Open in Gmail",
  refreshing: "Refreshing...",
} as const;
export default gmail;
